import React, { useEffect, useRef } from "react";
import Page1 from "./Page1.js";
import Page2 from "./Page2.js";
import Page3 from "./Page3.js";
import Page4 from "./Page4.js";
import { polyfill } from "seamless-scroll-polyfill";

function Pages() {
  const scrollRef = useRef();

  if (typeof window !== "undefined") {
    polyfill(); 
  }  

  useEffect(() => { 
    if (typeof window === "undefined") { 
      return;
    } 

    const handleScroll = (event) => {
      const offsetHeight =
      document.getElementsByClassName("glslRenderer")[0].offsetHeight;
      if(window.innerHeight + window.scrollY > offsetHeight) {
        scrollRef.current.style.display = "none";
        return;
      }
      scrollRef.current.style.display = "block";
      /**if(window.scrollY > 0){
        document.getElementsByClassName("scrollContainer")[0].style.display = 'none';
      }else{
        document.getElementsByClassName("scrollContainer")[0].style.display = 'initial';
      }**/
    };
    window.addEventListener("scroll", handleScroll);
    window.addEventListener("load", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("load", handleScroll);
    };
  }, []);

  return (
    <div id="pages">
      <Page1 />
      <Page2 />
      <Page3 />
      <div id="gap-page" className="page"/>
      <Page4 />
      <div className="scrollContainer" ref={scrollRef}>
        <div className="scroll">
          <img src="/arrow.png" alt="Scroll Down" width={60} height={60} loading="lazy"/>
        </div>
      </div>
    </div>
  );
}

export default Pages;
